import store from "@/store/index";
import { msalInstance } from "@/authConfig";

export function logout() {
  const isKiosk = store.getters["shared/isKiosk"];
  const account = msalInstance.getActiveAccount();
  const tokenId = "msal." + process.env.VUE_APP_CLIENTID + ".idtoken";
  localStorage.removeItem(tokenId);
  localStorage.removeItem("tableBt");

  if (isKiosk) {
    if ((window as any).winSimployer) {
      (window as any).winSimployer.close();
    }
    (window as any).winSimployer = window.open(
      "https://trysilhus.capitech.no/Auth0/Logout"
    );
    setTimeout(() => {
      (window as any).winSimployer.close();
      (window as any).winSimployer = null;
      msalInstance.logoutRedirect({ account: account });
    }, 800);
  } else {
    msalInstance.logoutRedirect({ account: account });
  }
}
